var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrSmall = function SvgQrSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5.25h-4.5v4.5h4.5v-4.5Zm-6-1.5v7.5h7.5v-7.5h-7.5Zm6 10.5h-4.5v4.5h4.5v-4.5Zm-6-1.5v7.5h7.5v-7.5h-7.5Zm10.5-7.5h4.5v4.5h-4.5v-4.5Zm-1.5 6v-7.5h7.5v7.5h-7.5Zm0 6v-4.5h1.5v4.5h-1.5Zm-6-10.5v1.5h1.5v-1.5h-1.5Zm0 10.5v-1.5h1.5v1.5h-1.5Zm9-10.5v1.5h1.5v-1.5h-1.5Zm3 13.5V18h1.5v2.25h-1.5Zm0-7.5V15h-1.5v-2.25h-1.5v6h-3v1.5h4.5V16.5h3v-3.75h-1.5Z",
    fill: "#317E72"
  })));
};
export default SvgQrSmall;